var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("VanTabbar", {
    staticClass: "bg-[#fff] border-t-solid border-t-[0.5px] border-t-[#ebebeb] pt-2 pb-4 !h-auto flex-shrink-0",
    attrs: {
      fixed: false
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.active,
      callback: function callback($$v) {
        _vm.active = $$v;
      },
      expression: "active"
    }
  }, _vm._l(_vm.data, function (item, index) {
    return _c("VanTabbarItem", {
      key: index,
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function fn() {
          return [_c("i", {
            staticClass: "iconfont text-[24px] mb-[2px]",
            class: [_vm.handleSetTabBarIcon(item, index), _vm.active === index ? "text-[#000]" : "text-[#929292]"]
          })];
        },
        proxy: true
      }], null, true)
    }, [_c("p", {
      staticClass: "text-[10px] font-normal text-center",
      class: [_vm.active === index ? "text-[#000]" : "text-[#929292]"]
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]);
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };